<template>
  <modal name="attach-lots-modal"
         @before-open="handleBeforeOpen"
         @before-close="handleBeforeClose"
         style="z-index: 1001;">
    <div id="modal-header" class="w-100 px-4 py-2 position-relative"
         style="background-color:#1e7bb7">
      <div class="w-100 d-flex">
        <h4 class="text-white">Կցել չափաբաժիններ</h4>
      </div>
      <button type="button"
              class="close position-absolute"
              style="right: 1.25rem; top: 30%"
              @click="$modal.hide('attach-lots-modal')" aria-label="Close">
        <span aria-hidden="true" class="text-white">&times;</span>
      </button>
    </div>
    <div id="modal-body" class="p-4" style="overflow-x: auto; height: 85%">
      <div class="row h-100">
        <div class="col-6">
          <div v-if="availableLots.length" class="checkbox checkbox-primary pl-1 mb-3">
            <input id="select-all" @change="handleSelectAll" :checked="allSelected" type="checkbox">
            <label for="select-all" class="text-primary">Ընտրել բոլորը</label>
          </div>
          <div v-for="(row, index) in availableLots"
               :key="index"
               class="checkbox checkbox-info mb-1 p-3">
            <input :id="'lot-' + index" :value="row" v-model="selectedLots" type="checkbox">
            <label :for="'lot-' + index" class="">
              <table class="text-center">
                <thead>
                  <tr>
                    <th class="px-2">Չ/Բ</th>
                    <th class="px-2">Կոդ</th>
                    <th class="px-2">Անվանում</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="px-2">{{ row.view_id }}</td>
                    <td class="px-2">{{ row.cpv_code }}{{ row.cpv_drop && '/' }}{{ row.cpv_drop }}</td>
                    <td class="px-2">{{ row.cpv_name }}</td>
                  </tr>
                </tbody>
              </table>
            </label>
          </div>
          <infinite-loading ref="infiniteLoading" @infinite="infiniteHandler">
            <div slot="no-results"></div>
            <div slot="no-more"></div>
          </infinite-loading>
        </div>
        <div class="col-6 border-left" style="overflow-y: auto;">
          <div class="row px-3">
            <div class="border border-primary position-relative rounded m-1 px-3 py-1 text-primary col-auto"
                 v-for="(lot, index) in selectedLots" :key="index">
              <span class="mr-3">{{ lot.view_id }} - {{ lot.cpv_code }}{{ lot.cpv_drop && '/' }}{{ lot.cpv_dro}} - {{ lot.cpv_name }}</span>
              <font-awesome-icon @click="remove(lot)"
                                 icon="times"
                                 class="position-absolute"
                                 style="cursor: pointer; right: 10px; top: calc(50% - 8px);"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="modal-footer" class="bg-white position-absolute w-100 p-3 text-right" style="bottom: 0">
      <button @click="$modal.hide('attach-lots-modal')" class="btn btn-sm btn-light mr-3">
        Չեղարկել
      </button>
      <button @click="save" type="button" class="btn btn-sm btn-primary">
        Պահպանել
      </button>
    </div>
  </modal>
</template>

<script>
  import InfiniteLoading from 'vue-infinite-loading'

  export default {
    name: 'AttachLotsModal',
    components: { InfiniteLoading },
    data() {
      return {
        allSelected: false,
        organizedLots: [],
        alreadyAttached: [],
        selectedLots: [],
        pagination: {}
      }
    },
    computed: {
      availableLots() {
        // eslint-disable-next-line no-undef
        return _.differenceBy(this.organizedLots, this.alreadyAttached, 'id')
      }
    },
    watch: {
      selectedLots(lots) {
        console.log(lots)
        this.allSelected = lots.length && lots.length === this.availableLots.length
      }
    },
    methods: {
      save() {
        if(this.selectedLots.length) {
          // eslint-disable-next-line no-undef
          this.$emit('lots-select', this.selectedLots)
          this.$modal.hide('attach-lots-modal')
        }
      },
      infiniteHandler($state) {
        this.$store.dispatch('organize/getRows', {
          organizeId: this.$route.params.id,
          page: this.pagination.page ? this.pagination.page + 1 :  1
        }).then(({ data }) => {
          if(data.data.length) {
            this.pagination = data.pagination
            this.organizedLots.push(...data.data)
            if(this.allSelected) {
              this.selectedLots.push(...data.data)
            }
            $state.complete()
          } else{
            $state.complete()
          }
        })
      },
      handleSelectAll() {
        const isAllSelected = !this.allSelected // next value
        // eslint-disable-next-line no-undef
        this.selectedLots = isAllSelected ? _.cloneDeep(this.availableLots) : []
        this.allSelected = isAllSelected
      },
      remove(removableLot) {
        const index = this.selectedLots.findIndex(lot => lot.id === removableLot.id)
        if(index > -1) {
          this.selectedLots.splice(index, 1)
        }
      },
      handleBeforeOpen({ params }) {
        // eslint-disable-next-line no-undef
        this.alreadyAttached = params.attachedLots
      },
      handleBeforeClose() {
        Object.assign(this.$data, {
          allSelected: false,
          organizedLots: [],
          selectedLots: [],
          pagination: {}
        })
      }
    }
  }
</script>

<style scoped>
  /deep/ .vm--modal {
    top: 3rem !important;
    left: unset !important;
    width: 70% !important;
    height: 80% !important;
    margin: auto;
    -webkit-border-radius: .3rem !important;
    -moz-border-radius: .3rem !important;
    border-radius: .3rem !important;
  }
</style>
